import { Injectable } from '@angular/core';

import { DynamicEntity, DynamicEntityCreate } from '../models/dynamic-entity';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { DynamicEntityPagedData } from '../models/dynamic-entity-paged-data';
import { DynamicEntityDataRequest } from '../models/dynamic-entity-data-request';
import { ForeignKeyField } from '../models/foreign-key-field';
import { DynamicEntityRecordCreate } from '../models/dynamic-entity-record-create';

@Injectable({
  providedIn: 'root'
})
export class DictionaryService {

  constructor(private http: HttpClient) { }

  getAllDynamicEntities() {
    return this.http.get<DynamicEntity[]>(`${environment.urlApi}/entities/internal`);
  }

  getById(id: string | undefined) {
    return this.http.get<DynamicEntity>(`${environment.urlApi}/entities/internal/${id}`);
  }

  putSaveDynamicEntity(request: DynamicEntityCreate, id: string){
    return this.http.put(`${environment.urlApi}/entities/internal/${id}`, request);
  }

  getDynamicEntityRecords(request: DynamicEntityDataRequest, dynamicEntityId: string){
    return this.http.post<DynamicEntityPagedData>(`${environment.urlApi}/entities/internal/${dynamicEntityId}/records/filtered`, request);
  }

  createDynamicEntityRecord(dynamicEntityId: string, body: DynamicEntityRecordCreate){
    return this.http.post(`${environment.urlApi}/entities/internal/${dynamicEntityId}/records`, body);
  }

  updateDynamicEntityRecord(dynamicEntityId: string, body: DynamicEntityRecordCreate,  recordId: string) { 
    return this.http.put(`${environment.urlApi}/entities/internal/${dynamicEntityId}/records/${recordId}`, body);
  }

  createDynamicEntity(request: DynamicEntityCreate, organizationId: number){
    return this.http.post(`${environment.urlApi}/entities/internal/organization/${organizationId}`, request);
  }

  getForeignKeysByEntityId(entityId: string){
    return this.http.get<ForeignKeyField[]>(`${environment.urlApi}/entities/internal/${entityId}/functional-key`);
  }

  deleteRecord(dynamicEntityId: string, recordId: string){
    return this.http.delete(`${environment.urlApi}/entities/internal/${dynamicEntityId}/records/${recordId}`);
  }

  getRecordById(dynamicEntityId: string, recordId: string){
    return this.http.get(`${environment.urlApi}/entities/internal/${dynamicEntityId}/records/${recordId}`);
  }

  deleteDynamicEntity(id: string){
    return this.http.delete(`${environment.urlApi}/entities/internal/${id}`);
  }

  getAllDynamicEntitiesByOrganizationId(organizationId: number) {
    return this.http.get<DynamicEntity[]>(`${environment.urlApi}/entities/internal/organization/${organizationId}`);
  }

  setPermission(entityId: string, canRead: boolean, canWrite: boolean, canUpdate: boolean, canDelete: boolean, ){
    const permission = { canRead, canWrite, canUpdate, canDelete };

    return this.http.post(`${environment.urlApi}/entities/internal/${entityId}/permission`, {permission});
  }

  async getProcessConfigByCode(code: string): Promise<DynamicEntityPagedData> {

  return new Promise((resolve, reject) => {

    const dataRequest: DynamicEntityDataRequest = {
      pageNumber: 1,
      pageSize: 1,
      filters: [
        {
          field: 'code',
          value: code,
        }
      ]
    }

    this.getDynamicEntityRecords(dataRequest, environment.processConfigEntityId)
      .subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (error) => {
          console.error('Error getting process config:', error);
          reject(error);
        }
      });
  });
  }


  async createTelarContextMaster(idIaModel: string): Promise<any> {
  const body: DynamicEntityRecordCreate = {
    record: [
      { field: 'idIaModel', value: idIaModel },
    ]
  };
  return new Promise((resolve, reject) => {
    this.createDynamicEntityRecord(environment.cotextMasterEtityId, body)
      .subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (error) => {
          console.error('Error creating Context Master:', error);
          reject(error);
        }
      });
  });
}

}